export default [
  {
    title: 'Parameters',
    icon: 'cogs',
    route: 'General parameters',
    resource: 'Parameters',
    action: 'manage',
  },
]
